import React, { useRef } from "react";
import { Button, Modal } from "antd";

const AepsOtpVerifyModal = ({
  isOpen,
  setIsOpen,
  otp,
  setOtp,
  setTransactionTwoFaModal,
}) => {
  const inputRefs = useRef([]);

  const handleChange = (index, value) => {
    // Allow only digits
    if (!/^\d?$/.test(value)) return;

    const otpArray = otp.split("");
    otpArray[index] = value;

    const newOtp = otpArray.join("");
    setOtp(newOtp);

    // Move to next input
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handleSubmit = () => {
    if (otp.length !== 6) return;

    setIsOpen(false);
    setTransactionTwoFaModal(true);
  };

  return (
    <Modal
      title="Verify OTP"
      footer={null}
      open={isOpen}
      width={300}
      maskClosable={false}
      onCancel={() => setIsOpen(false)}
    >
      <p className="text-center text-gray-500 mb-5">Enter OTP</p>

      <div className="flex justify-center gap-2">
        {[0, 1, 2, 3, 4, 5].map((index) => (
          <input
            key={index}
            ref={(el) => (inputRefs.current[index] = el)}
            type="text"
            inputMode="numeric"
            maxLength={1}
            className="w-10 h-10 text-center rounded border"
            value={otp[index] || ""}
            onChange={(e) => handleChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
          />
        ))}
      </div>

      <Button
        className="bg-primary mt-4 w-full border-none rounded-md h-9 text-center text-white flex justify-center items-center font-bold text-md cursor-pointer"
        type="primary"
        disabled={otp.length !== 6}
        onClick={handleSubmit}
      >
        Verify OTP
      </Button>
    </Modal>
  );
};

export default AepsOtpVerifyModal;
